import { createReducer, on } from "@ngrx/store";
import { FlowListResponse } from "src/app/common/models/interaction/flow.model";
import {
    fetchFlowList,
    fetchFlowListSuccess,
    fetchFlowListFailed,
    clearFlowList,
    updateFlowInList,
} from "./flow-list-actions";

export interface FlowListState {
    flows: FlowListResponse[];
    isLoading: boolean;
    error: string | null;
}

const initialState: FlowListState = {
    flows: [],
    isLoading: false,
    error: null
};

export const FlowListReducer = createReducer(
    initialState,
    on(fetchFlowList, (state) => ({
        ...state,
        isLoading: true,
        error: null
    })),
    on(fetchFlowListSuccess, (state, { flows }) => ({
        ...state,
        flows,
        isLoading: false,
        error: null
    })),
    on(fetchFlowListFailed, (state, { error }) => ({
        ...state,
        isLoading: false,
        error
    })),
    on(clearFlowList, (state) => ({
        ...state,
        flows: [],
        error: null
    })),
    on(updateFlowInList, (state, { flow }) => ({
        ...state,
        flows: state.flows.map((f) => f.id === flow.id ? { ...f, ...flow } : f),
    }))
);
